import { render, staticRenderFns } from "./datetime-editor.vue?vue&type=template&id=85da27d4&"
import script from "./datetime-editor.vue?vue&type=script&lang=js&"
export * from "./datetime-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports